import { config } from './config';

export default function subscribe() {
  const subscribeButton = document.querySelector('#subscribe-button');
  if (!subscribeButton) {
    console.warn("No element with id 'subscribe-button' found");
    return;
  }
  const subscribeInput = document.querySelector('#subscribe-input');
  if (!subscribeInput) {
    console.warn("No element with id 'subscribe-input' found");
    return;
  }
  subscribeButton.addEventListener('click', function () {
    const email = subscribeInput.value;
    fetch(config.url + '/email', {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain',
      },
      body: JSON.stringify({ email }),
    });
    subscribeInput.value = '';
  });
}
